import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.classList.remove("opacity-100");
      this.element.classList.add("opacity-0");
    }, 3000);
  }
}
